<script>
export default {
	beforeRouteEnter: (to, from, next) => {
		next(vm => {
			vm.$store.dispatch("triggerLoading", false);
		});
	}
};
</script>